import styled from "styled-components";

export const ExpandablesContainer = styled("div")`
  padding: 0 2vw;
  margin: 3vw 0;
  position: relative;
  z-index: 0;
  padding-bottom: 4vw;
`;
